import { createContext, useCallback, useState } from 'react';

import { Notification, ToastContextData, ToastProviderProps } from './types';

export const ToastContext = createContext<ToastContextData>({} as ToastContextData);

export const ToastProvider = ({ children }: ToastProviderProps) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const addToast = useCallback((notification: Omit<Notification, 'id'>) => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { v4: uuid } = require('uuid');
    const id = uuid();

    const newNotification = {
      id,
      ...notification,
    };

    setNotifications((state) => [...state, newNotification]);
  }, []);

  const closeToast = useCallback(
    (id: string) => {
      setNotifications(notifications.filter((notification) => notification.id !== id));
    },
    [notifications],
  );

  return (
    <ToastContext.Provider
      value={{
        notifications,
        addToast,
        closeToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};
